import { ConfigurationGeneration } from './configurationGeneration.model';
import { KycConsentConfig } from './kycConsentConfig.model';
import { Translation } from './translation.model';
import { ValidationRule } from './validationRule.model';

export class AddUtility {
  name: string = '';
  subdomain: string = '';
  colorCode: string = '';
  dashboardConfiguration: DashboardConfiguration[] = [];
  image: File | null;
}

export class UtilityList {
  id: number = 0;
  name: string = '';
  subDomain: string = '';
  colorCode: string = '';
  imageUrl: string = '';
  status: string = '';
  deploymentStatus: string = '';
  deploymentInitialCreation: string = '';
  deploymentPdfGeneration: string = '';
  deploymentSubdomainCreation: string = '';
  deploymentDatabasesCreation: string = '';
  deploymentConfigurationCopy: string = '';
}
export class UtilityDetails {
  id: number = 0;
  name: string = '';
  fullName: string = '';
  subdomain: string = '';
  colorCode: string = '';
  imageUrl: string = '';
  dashboardConfiguration: DashboardConfiguration[] = [];
  translations: Translation[] = [];
  validationRules: ValidationRule[] = [];
  configurationGenerations: ConfigurationGeneration[] = [];
  kycConsentConfiguration: KycConsentConfig = new KycConsentConfig();
  contactPerson: ContactPerson = new ContactPerson();
  bankDetails: BankDetails = new BankDetails();
  currency: string = '';
  country: string = '';
  language: string = '';
  codePatterns: CodePattern[] = [];
  defaultCaimsCodePatterns: boolean = true;
  mapConfiguration?: MapConfiguration;
  maximumSelectedAreasForMobile?: number;
  isSelectedAreasForMobileLimited?: boolean;
  senderEmail?: string;
  sendgridApiKey?: string;
}
export class ContactPerson {
  firstName: string = '';
  lastName: string = '';
  eMail: string = '';
}

export enum DashboardConfiguration {
  Buildings = 0,
  Meters = 1,
  Poles = 2,
  DTs = 3,
  Feeders = 4,
  Survey = 5,
  Installation = 6,
  WorkOrder = 7,
  MeterCustomers = 8,
  CustomerManagement = 9,
  Readings = 10,
  StandaloneBillingIntegration = 11,
  Map = 12,
  MVPoles = 13,
  Rmus = 14,
  NewService = 15,
  AccountCreation = 16,
  MeterValidationTamper = 17,
  MeterValidation = 18,
  DtConfirmation = 19,
  EnergySource = 20,
  AIDroneMap = 21, 
  NetworkModelStructure = 22,
  NetworkEntityClassInstantiation = 23,
  DataModelCustomization = 24,
  InjectionSubstation = 25,
  FeederBands = 26,
  PaymentHistory = 27,
  CustomerInformationEdit = 28,
  CIMDataIntegration = 29,
  GalleryAccessAssets = 30,
  GalleryAccessOperations = 31,
  OnlineMeterNumberScan = 32,
  MeterAssets = 33,
  MeterCtvt = 34,
  DtMeterInstallation = 35,
  MeterApprovalAndRepayment = 36,
  Settlement = 37,
}

export class UtilityBasicInfo {
  id: number = 0;
  name: string = '';
  currency: string = '';
}

export class BankDetails {
  bankName: string = '';
  accountName: string = '';
  accountNumber: string = '';
}

export class UtilityLanguageSuffix {
  language: number = 0;
  suffix: string = '';
}

export class CodePattern {
  assetType: CodedAssetType;
  prefix: string = '';
  codePatternOption?: CodePatternOptions;
  displayPatternOption?: string;
  displayAssetType?: string;
}

export enum CodedAssetType {
  TransmissionStation = 1,
  Feeder33 = 2,
  Substation = 3,
  Feeder11 = 4,
  Dt = 5,
  Pole = 6,
  Building = 7,
  Customer = 8,
}

export enum CodePatternOptions {
  SingleNumeric = 1,
  DoubleNumeric = 2,
  TripleNumeric = 3,
  QuadrupleNumeric = 4,
  SingleAlphabet = 5,
  DoubleAlphabet = 6,
  TripleAlphabet = 7,
  AlphaNumericSingle = 8,
  AlphaNumericDouble = 9,
  AlphaNumericTriple = 10,
  AlphaNumericQuadruple = 11
}

export class MapConfiguration {
  id: number;
  latitude?: number;
  longitude?: number;
  zoom?: number;
  mapType?: string;
  mapTheme?: string;
}
